import { NgModule } from '@angular/core';
import { addNavMenuItem, SharedModule } from '@vendure/admin-ui/core';

@NgModule({
    imports: [SharedModule],
    providers: [
        addNavMenuItem(
            {
                id: 'social',
                label: 'Social Media',
                routerLink: ['/extensions/social'],
                icon: 'group',
            },
            'settings'
        ),
    ],
})
export class ChannelSocialMediaNavModule {}
